module.exports = __webpack_public_path__ + "img/aParty_1208_C.c98e7693.jpg";